import styled from 'styled-components';

// Question
export const Box = styled.div`
  width: 100%;
  padding: 1rem;
  margin: auto;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  background: #e9e9e9;
`;

export const TextRed = styled.span`
  color: red;
`;

export const Timer = styled.p`
  font-size: 0.875rem;
  white-space: nowrap;
`;

export const Square = styled.div<{ isRecording: boolean }>`
  width: 1rem;
  height: 0.75rem;
  border-radius: ${({ isRecording }) => (isRecording ? '0.125rem' : '50%')};
  background: ${({ isRecording }) => (isRecording ? '#9f9f9f' : '#de8ca8')};
  transition: all 0.3s ease-in-out;
`;

export const VoiceIndicator = styled.div`
  width: 50px;
  display: flex;
  justify-content: center;
`;
